if (!customElements.get('natunora-joints-marquee')) {
  customElements.define('natunora-joints-marquee', class extends HTMLElement {
    connectedCallback() {
      this.observer?.disconnect();
      const track = this.querySelector('.natunora-joints-marquee__track');
      const group = track?.firstElementChild;
      if (!group) return;
      const measure = () => {
        const width = group.getBoundingClientRect().width;
        if (!width) return;
        const count = Math.max(2, Math.ceil(this.clientWidth / width) + 1);
        while (track.children.length < count) track.append(group.cloneNode(true));
        while (track.children.length > count) track.lastElementChild.remove();
        track.style.setProperty('--natunora-marquee-shift', `${-width}px`);
      };
      this.observer = new ResizeObserver(measure);
      this.observer.observe(this);
      this.observer.observe(group);
      measure();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
    }
  });
}
